import { State, Module } from 'vuex-simple';
import { BaseModule, createHandler } from '@/HostApp/store/ApsModules/BaseModule';

import { serverProps } from '@/Common/Environment/const';

import appModule, { AppModule } from '@/HostApp/store/ApsModules/AppModule';
import apscModule, { ApscModule } from '@/HostApp/store/ApsModules/ApscModule';
import contextModule, { ContextModule } from '@/HostApp/store/ApsModules/ContextModule';
import navigationModule, { NavigationModule } from '@/HostApp/store/ApsModules/NavigationModule';
import notificationsModule, { NotificationsModule } from '@/HostApp/store/ApsModules/NotificationsModule';

import { HostServices } from '@/HostApp/services';

export class ApsModule extends BaseModule {
	constructor() {
		super();
		/**
		 * By default, @Module has only getter, to redefine this behavior use 'createHandler' to call
		 * 'updateState' method in a nested module to extend standard handler with set: (value)=> { this.updateState(value) }.
		 * Parent class BaseModule has a method 'updateState' to parse incoming values if something try to replace a module property
		 **/

		Object.defineProperty(this, 'app', createHandler(this.app));
		Object.defineProperty(this, 'apsc', createHandler(this.apsc));
		Object.defineProperty(this, 'context', createHandler(this.context));
		Object.defineProperty(this, 'navigation', createHandler(this.navigation));
		Object.defineProperty(this, 'notifications', createHandler(this.notifications));
	}

	//public hostServices: HostServices = hostServices;

	/**
	 * @State decorator creates a handler 'propName' : {
	 * 		get: () => { return Vuex.store.propName },
	 * 		set: (value) => { Vuex.store.commit(propName, value)}
	 * 	}
	 *
	 * 	to make any value from window.aps reactive, just describe it here with decorator @State()
	 **/

	public hostServices!: HostServices;

	@Module()
	public app: AppModule = appModule;

	@Module()
	public apsc: ApscModule = apscModule;

	@Module()
	public context: ContextModule = contextModule;

	@Module()
	public navigation: NavigationModule = navigationModule;

	@Module()
	public notifications: NotificationsModule = notificationsModule;

	@State()
	public devMode: boolean = false;

	@State()
	public placeholder: string = '';

	@State()
	public buttonsContainerId: string = '';

	@State()
	public types: APS.Types = {};

	@State()
	public version: string = '';

	@State()
	public wizard: APS.IWizard = {
		active: false,
		activeStep: -1,
		view: {} as APS.IView,
		steps: [] as Array<APS.IWizardState>
	};
}

const aps = new ApsModule();

(function setInitialValues(module: ApsModule): void {
	const context: Partial<ContextModule> = {
		bs: true,
		css: [serverProps.bootstrapCSSPath],
		googleApiKey: serverProps.googleApiKey,
		visibleMode: serverProps.clientType,
		accountType: serverProps.accountType,
		accountCreatedAt: serverProps.accountCreatedAt,
		user: serverProps.apsContext.user,

		_token: serverProps.apsContext._token,
		_sessionId: serverProps.apsContext._sessionId,
		_locale: serverProps.locale,
		_copyright: serverProps.copyrights?.show ? serverProps.copyrights : undefined,
		_anonymousUrlPath: serverProps.apsContext._anonymousUrlPath
	};

	module.context = context as ContextModule;

	module.devMode = serverProps.devMode;
	module.types = serverProps.apsTypes;
	module.version = serverProps.uiRuntimeVersion;
	module.placeholder = serverProps.placeholder;
	module.buttonsContainerId = 'bottom-buttons';
	module.navigation.userMenu = serverProps.userMenu;
	module.navigation.helpMenu = serverProps.helpMenu;
	module.navigation.vueWorkspace = serverProps._vueWorkspace;

	module.navigation.tree = serverProps.navigationTree;

	window._ux1TopWindow = true;
})(aps);

Object.defineProperty(window, 'aps', createHandler(aps));

export default aps;
